import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowDownFromLine = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19 4H5c-.55 0-1-.45-1-1s.45-1 1-1h14c.55 0 1 .45 1 1s-.45 1-1 1"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m11 18.6-3.3-3.3a.996.996 0 1 0-1.41 1.41l5 5c.198.188.444.287.7.29h-.01.02a1 1 0 0 0 .794-.394l4.896-4.896a.996.996 0 1 0-1.41-1.41L13 18.58V7c0-.55-.45-1-1-1s-1 .45-1 1zm.99 3.4"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgArrowDownFromLine;
